<template>
  <div class="content">
    <div class="row">
      <h3 class="col is-center text-grey">{{ msg }}</h3>
    </div>
    <div class="row">
      <div class="col is-center">
        <div class="card idea-card">
          <p><em>Think</em>&nbsp;&nbsp;&nbsp;<strong>{{ techOne }}</strong></p>
          <p><em>meets</em>&nbsp;&nbsp;<strong>{{ techTwo }}</strong></p>
          <p><em>meets</em>&nbsp;&nbsp;<strong>{{ commonNoun }}</strong></p>
          <footer>
            <button class="button primary" @click="regenerate">Re-generate</button>
            <button class="button" @click="copyToClipboard">{{ copyLabel }}</button>
          </footer>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as CommonNouns from '../wordlists/common-nouns'
import * as TechCompanies from '../wordlists/tech-companies'

const description = 'Are you looking for your next startup idea? Look no further.'
const image = process.env.BASE_DOMAIN + require('../assets/fail.jpg')
const title = 'StartupIdea.Fail - Where Startup Ideas go to Fail'

export default {
  name: 'Home',
  data () {
    const pair = TechCompanies.getPair()
    return {
      techOne: pair[0],
      techTwo: pair[1],
      commonNoun: CommonNouns.get(),
      copyLabel: 'Copy'
    }
  },
  methods: {
    regenerate () {
      const pair = TechCompanies.getPair()
      this.techOne = pair[0]
      this.techTwo = pair[1]
      this.commonNoun = CommonNouns.get()
      this.copyLabel = 'Copy'
    },
    copyToClipboard () {
      const textToCopy = `New Startup Idea:

Think ${this.techOne} meets ${this.techTwo} meets ${this.commonNoun}

Generate your own idea at:
${process.env.BASE_DOMAIN}`
      return this.$copyText(textToCopy)
        .then(e => {
          console.log('copied!', e)
          this.copyLabel = 'Copied!'
        })
        .catch(err => {
          console.log('not copied :(', err)
        })
    }
  },
  props: {
    msg: String
  },
  metaInfo: {
    title,
    htmlAttrs: {
      lang: 'en'
    },
    meta: [
      {
        name: 'description',
        content: description
      },
      {
        property: 'og:description',
        content: description,
        vmid: 'og:description'
      },
      {
        property: 'og:image',
        content: image,
        vmid: 'og:image'
      },
      {
        property: 'og:title',
        content: title,
        vmid: 'og:title'
      },
      {
        property: 'og:type',
        content: 'website',
        vmid: 'og:type'
      }
    ]
  }
}
</script>

<style>
  .content > .row {
    margin-bottom: 2em;
  }
  .idea-card {
    font-size: 18px;
    min-width: 320px;
  }
  .idea-card strong {
    font-size: 22px;
  }
</style>
